import React from "react";
import { useMsal } from "@azure/msal-react";
import Card from "./common/Card";
import Icon from "./common/Icon";
import { useAuthInfo } from "../context/AuthInfoContext";
import { clearAuthSessionState } from "../utils/authRedirect";
import { TOEWIJZING_NIET_ACTIEF, WACHT_OP_TOEGANG } from "../utils/authMessages";
import "../pages/diagnostics/systemPages.css";

// Wachtpagina (issue #23): aangemeld, maar nog geen rol. Vroeger ging zo'n gebruiker terug naar de login,
// die hem meteen weer doorstuurde. Nu staat hij in de lijst "Wacht op toegang" bij Beheer (access_person_touch
// bij auth/me) en ziet hij hier wat er gebeurt. Een toewijzing werkt binnen een minuut: "Opnieuw controleren".
export default function WaitingForAccess() {
  const { instance, accounts } = useMsal();
  const { access, user, refresh } = useAuthInfo();
  const account = instance?.getActiveAccount?.() || accounts?.[0];
  const name = account?.name || user?.name || "";
  const email = account?.username || "";
  // Op deze pagina is access.waiting altijd waar, dus dat onderscheidt niets. Wel: rollen in access.roles = de persoon
  // heeft minstens één ACTIEVE toewijzing (api.access_me_get geeft enkel actieve), maar die geeft nog geen toegang
  // (bv. enkel Assistent). Geen rollen = geen actieve toewijzing (issue #23 F5: ook niet via een Entra-rol). Toewijzingen
  // die nog niet of niet meer actief zijn, kan auth/me niet zien: die vallen onder "nog geen toegang".
  const noAssignment = !(Array.isArray(access?.roles) && access.roles.length > 0);

  const logout = () => {
    clearAuthSessionState();
    instance?.logoutRedirect?.();
  };

  return (
    <main className="sp-page sp-page--inline">
      <Card className="sp-card">
        <span className="sp-wait-icon" aria-hidden="true">
          <Icon name="shield" size={24} />
        </span>
        <h1 className="sp-title">Nog geen toegang</h1>
        <p className="sp-text">{noAssignment ? WACHT_OP_TOEGANG : TOEWIJZING_NIET_ACTIEF}</p>
        {name || email ? (
          <p className="sp-text sp-text--muted">
            Aangemeld als <strong>{name || email}</strong>
            {name && email ? ` (${email})` : ""}.
          </p>
        ) : null}
        <ol className="sp-steps">
          <li>Bij je aanmelding verschijn je bij Beheer in de lijst &quot;Wacht op toegang&quot;.</li>
          <li>Beheer kent je rollen en bereik toe (welke entiteiten en banken je ziet).</li>
          <li>Binnen een minuut daarna werkt je toegang. Klik dan op &quot;Opnieuw controleren&quot;.</li>
        </ol>
        <div className="sp-actions">
          <button type="button" className="btn-primary-green sp-btn" onClick={() => refresh?.()}>
            Opnieuw controleren
          </button>
          <button type="button" className="btn-outline-green sp-btn" onClick={logout}>
            Afmelden en ander account
          </button>
        </div>
      </Card>
    </main>
  );
}
